<template>
    <div class="w-full">
        <div class="w-full mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    DAFTAR PASIEN RAWAT INAP
                </h1>
            </div>
            <div class="w-full md:w-1/2 mt-5 mx-auto">
                <SelectInput
                            v-model="statusData"
                            id="status"
                            label="STATUS"
                        >
                            <option value="">=== PILIH STATUS ===</option>
                            <option value="all">Semua</option>
                            <option value="active">Aktif</option>
                            <option value="out">Keluar</option>
                            <option value="void">Void</option>
                </SelectInput>
            </div>
            <div class="w-full md:w-1/2 mt-5 mb-5 mx-auto">
                <DateInput
                    v-model="tglMasukData"
                    class="w-full grow mr-5"
                    id="tgl_masuk"
                    label="PILIH TANGGAL MASUK BED"
                />
            </div>
            <div class="w-full md:w-1/2 mx-auto">
                <button
                    @click.prevent="getPasienRanap()"
                    class="bg-green-600 hover:bg-green-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs"
                >
                    CARI
                </button>
            </div>
            <div class="w-full my-3">
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm font-bold uppercase">
                        TOTAL PASIEN RANAP AKTIF: {{ pasienRanap.pasienRanapAktif }}
                    </p>
                </div>
                <div class="font-poppins mt-2 mb-2 text-right">
                    <p class="font-sm">
                        data diperbaharui pada :
                        <span class="text-red-500"
                            >{{ timerCount }} (10 Menit)</span
                        >
                    </p>
                </div>
                <div class="w-full grid grid-cols-2 gap-4">
                    <div v-for="pasienRanap in pasienRanapData.data" class="w-full bg-white rounded-md shadow p-3 mb-5">
                        <button
                                @click.prevent="exportExcel(pasienRanap.fsKdBangsal)"
                                class="bg-pink-600 hover:bg-pink-700 text-white font-bold rounded-3xl flex items-center px-5 py-5 justify-center text-center ml-auto self-end w-36 h-10 text-xs mr-2 mb-3"
                            >
                                EXPORT EXCEL
                            </button>
                        <div class="w-3/4 mx-auto bg-white rounded-md shadow overflow-x-auto scrollbar-track-black mb-3">
                            
                            <table class="w-full whitespace-nowrap">
                                <tr class="text-left font-bold bg-amber-100">
                                    <td class="py-2 px-3 text-center text-sm">RUANG</td>
                                    <td class="py-2 px-3 text-center text-sm">TERPAKAI</td>
                                    <td class="py-2 px-3 text-center text-sm">KOSONG</td>
                                </tr>
                                <tr class="hover:bg-gray-100">
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{pasienRanap.ruang}}</td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{pasienRanap.status.terpakai}}</td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">{{pasienRanap.status.kosong}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="bg-white rounded-md shadow overflow-x-auto scrollbar-thin scrollbar-thumb-amber-600 scrollbar-track-amber-300">
                        <table class="w-full whitespace-nowrap">
                            <thead>
                                <tr class="text-left font-bold bg-amber-100">
                                    <th class="py-2 px-3 text-center text-sm">
                                        No
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Nama BED
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Nama Pasien
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Alamat
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        No.Telp
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Register
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tgl. Masuk Reg
                                    </th>
                                    <!-- <th class="py-2 px-3 text-center text-sm">
                                        Tgl. Masuk Bed
                                    </th> -->
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tgl. Keluar Reg
                                    </th>
                                    <!-- <th class="py-2 px-3 text-center text-sm">
                                        Tgl. Keluar Bed
                                    </th> -->
                                    <th class="py-2 px-3 text-center text-sm">
                                        LOS
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Register
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Tarif RS
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Diag Utama
                                    </th>
                                    <th class="py-2 px-3 text-center text-sm">
                                        Diagnosa Text
                                    </th>   
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="pasien in pasienRanap.pasien"
                                    class="hover:bg-gray-100"
                                >
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{ pasien.no }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{pasien.nama_bed}}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.nama_pasien}}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{pasien.alamat_pasien}}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{pasien.fs_tlp_pasien}}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{pasien.register}}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{pasien.tgl_masuk_reg}}
                                    </td>
                                    <!-- <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{pasien.tgl_masuk_bed}}
                                    </td> -->
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{(pasien.tgl_keluar_reg === '3000-01-01')?'':pasien.tgl_keluar_reg}}
                                    </td>
                                    <!-- <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                       {{(pasien.tgl_keluar_bed === '3000-01-01')?'':pasien.tgl_keluar_bed}}
                                    </td> -->
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ pasien.los }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ pasien.status_registrasi }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer text-end">
                                        {{ Number(pasien.tarif_rs).toLocaleString("en-US") }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ pasien.fs_kd_diag_utama }} - {{ pasien.fs_nm_diag_utama }}
                                    </td>
                                    <td class="border-r border-t px-3 py-2 text-sm select-none cursor-pointer">
                                        {{ potongTeks(pasien.fs_diag_utama, 100) }} 
                                    </td>
                                </tr>
                                <tr class="bg-white hover:bg-gray-100 focus-within:bg-gray-100" v-if="pasienRanap.pasien.length === 0">
                                    <td class="border-r border-t text-sm select-none cursor-pointer" colspan="10">
                                        Belum ada data pasien rawat inap
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import LayoutAdminBig from "../../../Shared/LayoutAdminBig.vue";
import RandomShape from "../../../Shared/RandomShape.vue";
import DateInput from "../../../Shared/DateInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import SelectInput from "../../../Shared/SelectInput.vue";
export default {
    components: {
        Link,
        RandomShape,
        DateInput,
        TextInput,
        SelectInput
    },
    data() {
        return {
            tglMasukData: this.tglMasuk,
            statusData: this.status,
            pasienRanapData: this.pasienRanap,
            timerCount: 600
        };
    },
    watch: {
        timerCount: {
            handler(value) {
                if (value > 0) {
                    setTimeout(() => {
                        this.timerCount--;
                    }, 1000);
                } else {
                    this.getPasienRanap(this.activeData);
                }
            },
            immediate: true,
        },
    },
    props: {
        tglMasuk: String,
        status: String,
        pasienRanap: Object,
    },
    methods: {
        getPasienRanap() {
            this.$inertia.get(
                "/admin/pasien_ranap/ajax",
                {
                    tglMasuk: this.tglMasukData,
                    status: this.statusData
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.timerCount = 600;
                        this.pasienRanapData = page.props.additional.pasienRanap;
                    },
                }
            );
        },
        exportExcel(fsKdBangsal){
            location.href = '/admin/pasien_ranap/export/excel?tglMasuk='+this.tglMasukData+'&status='+this.statusData+'&fsKdBangsal='+fsKdBangsal;
        },
        potongTeks(teks, panjang = 100) {
            if (!teks) return '';
            return teks.length > panjang ? teks.slice(0, panjang) + '...' : teks;
        }
    },
    layout: LayoutAdminBig,
};
</script>
